"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const DateUtils = {
  SECONDS_PER_MINUTE: 60,
  DEFAULT_TIMEZONE_OFFSET: new Date().getTimezoneOffset(),
  TIME_FORMATS: {
    12: '12',
    24: '24'
  },

  // Получить unixtime на сейчас
  unixtime() {
    return Math.floor(new Date().getTime() / 1000);
  },

  // Привести дату к началу периода
  startOf(date, condition) {
    const newDate = new Date(date);

    switch (condition) {
      case 'day':
        newDate.setHours(0, 0, 0, 0);
        break;

      case 'week':
        const first = date.getDate() - date.getDay() + 1;
        newDate.setDate(first);
        newDate.setHours(0, 0, 0, 0);
        break;

      case 'month':
        newDate.setDate(1);
        newDate.setHours(0, 0, 0, 0);
        break;

      default:
        throw new Error(`Unsupported condition "${condition}"`);
    }

    return newDate;
  },

  // Привести дату к концу периода
  endOf(date, condition) {
    const newDate = new Date(date);

    switch (condition) {
      case 'day':
        newDate.setHours(23, 59, 59, 0);
        break;

      case 'week':
        const first = date.getDate() - date.getDay() + 1;
        const last = first + 6;
        newDate.setDate(last);
        newDate.setHours(23, 59, 59, 0);
        break;

      case 'month':
        newDate.setMonth(newDate.getMonth() + 1);
        newDate.setDate(0);
        newDate.setHours(23, 59, 59, 0);
        break;

      default:
        throw new Error(`Unsupported condition "${condition}"`);
    }

    return newDate;
  },

  // Получить unixtime конкретной даты
  dateToUnixtime(date) {
    return Math.floor(date.getTime() / 1000);
  },

  // Получить список месяцев
  getMonth(month, lang) {
    let monthNames;

    switch (lang) {
      case 'ru':
        monthNames = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
        break;

      default:
        monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    }

    return monthNames[month];
  },

  // Получить день недели
  getWeekday(date, lang = 'en') {
    if (!date) return '';
    const weekdays = {
      en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      ru: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота']
    };
    return weekdays[lang][date.getDay()];
  },

  addZero(num) {
    return num < 10 ? `0${num}` : num;
  },

  // Полчить объект с временем
  unixtime2Date(unixtime) {
    const mtime = +unixtime * 1000;
    const date = new Date(mtime);
    return {
      month: date.getMonth(),
      year: date.getFullYear(),
      day: date.getDate(),
      h: date.getHours(),
      m: date.getMinutes(),
      s: date.getSeconds()
    };
  },

  // Форматирование даты
  toDate(unixtime, format, timeFormat = this.TIME_FORMATS[24], lang = 'en') {
    if (!unixtime) return '-';
    const date = this.unixtime2Date(unixtime);
    const hours = timeFormat === this.TIME_FORMATS[12] ? date.h % 12 || 12 : date.h;
    const ampm = date.h < 12 ? 'AM' : 'PM';
    const replacements = {
      YYYY: date.year,
      MM: this.addZero(date.month + 1),
      DD: this.addZero(date.day),
      HH: this.addZero(hours),
      AMPM: ampm,
      mm: this.addZero(date.m),
      ss: this.addZero(date.s),
      M: this.getMonth(date.month, lang),
      m: this.getMonth(date.month, lang).substr(0, 3)
    };
    const replacementKeys = Object.keys(replacements).join('|');
    return format.replace(new RegExp(replacementKeys, 'g'), match => replacements[match]);
  },

  nonoSecToUnixtime(nano) {
    return (nano / 1000000000).toFixed(0);
  },

  // Относительная дата
  relativeDate(unixtime) {
    const now = this.unixtime();
    const delta = Math.round(now - unixtime);
    const minute = 60;
    const hour = minute * 60;
    const day = hour * 24;
    const month = day * 30;
    let fuzzy;

    if (delta < 30) {
      fuzzy = 'just now';
    } else if (delta < minute) {
      fuzzy = `${delta} seconds ago`;
    } else if (delta < 2 * minute) {
      fuzzy = 'a minute ago';
    } else if (delta < hour) {
      fuzzy = `${Math.floor(delta / minute)} minutes ago`;
    } else if (Math.floor(delta / hour) === 1) {
      fuzzy = '1 hour ago';
    } else if (delta < day) {
      fuzzy = `${Math.floor(delta / hour)} hours ago`;
    } else if (delta < day * 2) {
      fuzzy = 'yesterday';
    } else if (delta < month) {
      fuzzy = `${Math.floor(delta / day)} days ago`;
    } else if (Math.floor(delta / month) === 1) {
      fuzzy = 'month ago';
    } else {
      fuzzy = `${Math.floor(delta / month)} months ago`;
    }

    return fuzzy;
  },

  adjustTimezoneOffset(unix, toUTC = true) {
    const modifier = toUTC ? -1 : 1;
    return unix + this.DEFAULT_TIMEZONE_OFFSET * this.SECONDS_PER_MINUTE * modifier;
  },

  getTimezoneOffset(timezoneOffset, isUTC = false) {
    if (isUTC) return 0;
    return typeof timezoneOffset === 'number' ? timezoneOffset : this.DEFAULT_TIMEZONE_OFFSET;
  },

  todayStart() {
    return this.startOf(this.unixtime() * 1000, 'day').getTime() / 1000;
  },

  todayEnd() {
    return this.endOf(this.unixtime() * 1000, 'day').getTime() / 1000;
  },

  tomorrowStart() {
    return this.startOf((this.unixtime() + 24 * 60 * 60) * 1000, 'day').getTime() / 1000;
  },

  tomorrowEnd() {
    return this.endOf((this.unixtime() + 24 * 60 * 60) * 1000, 'day').getTime() / 1000;
  },

  yesterdayStart() {
    return this.startOf((this.unixtime() - 24 * 60 * 60) * 1000, 'day').getTime() / 1000;
  },

  yesterdayEnd() {
    return this.endOf((this.unixtime() - 24 * 60 * 60) * 1000, 'day').getTime() / 1000;
  },

  isToday(unixtime) {
    return unixtime >= this.todayStart() && unixtime < this.todayEnd();
  },

  isTomorrow(unixtime) {
    return unixtime >= this.tomorrowStart() && unixtime < this.tomorrowEnd();
  },

  isYesterday(unixtime) {
    return unixtime >= this.yesterdayStart() && unixtime < this.yesterdayEnd();
  },

  correctTime(h, m) {
    let hours = +h;
    let minutes = +m;

    if (isNaN(hours)) {
      hours = 0;
    } else if (h > 23) {
      hours = 23;
    }

    if (isNaN(minutes)) {
      minutes = 0;
    } else if (m > 59) {
      minutes = 59;
    }

    return {
      hours: DateUtils.addZero(hours),
      minutes: DateUtils.addZero(minutes)
    };
  },

  /**
   * Converts a Unix timestamp to a human-readable format.
   *
   * @param {number} unixtime - The Unix timestamp to convert.
   * @return {string} A string representing the Unix timestamp in a human-readable format.
   */
  toReadable(unixtime) {
    const absoluteUnixtime = Math.abs(unixtime);
    const seconds = absoluteUnixtime % 60;
    const minutes = Math.floor(absoluteUnixtime / 60 % 60);
    const hours = Math.floor(absoluteUnixtime / 3600 % 24);
    const days = Math.floor(absoluteUnixtime / 86400);
    let result = '';

    if (days > 0) {
      result += `${days} day${days > 1 ? 's' : ''} `;
    }

    if (hours > 0) {
      result += `${hours} hour${hours > 1 ? 's' : ''} `;
    }

    if (minutes > 0) {
      result += `${minutes} minute${minutes > 1 ? 's' : ''} `;
    }

    if (seconds > 0) {
      result += `${seconds} second${seconds > 1 ? 's' : ''}`;
    }

    if (result === '') {
      return '0 seconds';
    }

    if (unixtime < 0) {
      result = `-${result}`;
    }

    return result.trim();
  }

};
var _default = DateUtils;
exports.default = _default;